import { Directive, ElementRef, HostListener, inject, input, contentChildren, AfterViewInit } from '@angular/core';
import { explicitEffect } from 'ngxtension/explicit-effect';

@Directive({
  selector: 'cue-button[moveNextMaxLength], input[moveNextMaxLength], textarea[moveNextMaxLength]',
  standalone: true,
})
export class MoveNextByMaxLengthDirective {
  public elRef = inject(ElementRef);
  next: HTMLElement;
  keepLast = input(false);

  @HostListener('input', ['$event']) onKeyDown(keyboardEvent: any) {
    const target = keyboardEvent.target as HTMLInputElement | HTMLTextAreaElement | null;

    if (!target || target.maxLength !== target.value.length) return;

    keyboardEvent.preventDefault();

    if (this.next) {
      this.next.focus();
    }

    if (this.next == null && !this.keepLast()) {
      target.blur();
    }
  }
}

@Directive({
  selector: '[moveNextMaxLengthContainer]',
  standalone: true,
})
export class MoveNextByMaxLengthContainerDirective implements AfterViewInit {
  childrenDirectives = contentChildren(MoveNextByMaxLengthDirective, { descendants: true });

  sortThemAllEffect = explicitEffect([this.childrenDirectives], () => {
    this.sortThemAll();
  });

  sortThemAll() {
    const childrens = this.childrenDirectives();
    for (let i = 0; i < childrens.length - 1; i++) {
      childrens[i].next = childrens[i + 1]?.elRef.nativeElement;
    }
  }

  ngAfterViewInit() {
    this.sortThemAll();
  }
}
